$(document).ready(function () {
  initPageScroller();
});

function initPageScroller() {
  $('a.page-scroll').on('click', function (event) {

    var $anchor = $(this);

    $('html, body').stop().animate({

      scrollTop: $($anchor.attr('href').substring($anchor.attr('href').indexOf('#'))).offset().top

    }, 3500, 'easeInOutExpo');

    event.preventDefault();

  });
}
